module.exports = __webpack_public_path__ + "img/checkbox2.440c461a.png";